/**
 *
 * DiagnosisTag
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import DiagnosisIcon from 'assets/v2/DiagnosisIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.ecruDark};
    background: ${COLORS.ecruLight};
    border-color: ${COLORS.ecru};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.ecru};
    }
  }
`;

function DiagnosisTag({ label, ...props }) {
  return <StyledTag label={label} icon={<DiagnosisIcon />} {...props} />;
}

DiagnosisTag.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(DiagnosisTag);
